import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

import { AppReducerState, appReducer } from './reducer';

import { appMiddleware } from './middleware';
import { AuthReducerState, authReducer } from '../modules/auth/@store/reducer';
import { UserReducerState, userReducer } from '../modules/user/@store/reducer';
import { RoomReducerState, roomReducer } from '../modules/room/@store/reducer';
import { authMiddleware } from '../modules/auth/@store/middleware';
import { roomMiddleware } from '../modules/room/@store/middleware';
import { userMiddleware } from '../modules/user/@store/middleware';

declare var window: any;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export interface RootState {
    app: AppReducerState,
    auth: AuthReducerState;
    user: UserReducerState;
    room: RoomReducerState;
}

const reducers = combineReducers({
    'app': appReducer,
    'auth': authReducer,
    'room': roomReducer,
    'user': userReducer,
});

export const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(
            ...authMiddleware,
            ...roomMiddleware,
            ...appMiddleware,
            ...userMiddleware
        ),
    )
);